import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { Typography, Box , Skeleton} from '@mui/material';
import { makeStyles } from '@mui/styles';

import colors from '../../../constants/colors';
import CurrentContext from '../../../context/current-context';

const useStyles = makeStyles(() => ({
  root: {
    height: '200px',
    width: '100%',
    background: (selected) => (selected ? colors.blue : '#F8F8F8'),
    boxShadow: (selected) => (selected ? 'rgb(0 0 0 / 18%) 0px 4.8px 14.4px, rgb(0 0 0 / 22%) 0px 25.6px 57.6px' : ''),
    borderRadius: '4px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: (selected) => (selected ? colors.blue : '#F8F8F8'),
      boxShadow: (selected) => (selected ? '' : 'rgb(0 0 0 / 18%) 0px 4.8px 14.4px, rgb(0 0 0 / 22%) 0px 25.6px 57.6px'),
    },
    '&:hover h5': {
      color: (selected) => (selected ? colors.white : '#000'),
    },
  },
  heading: {
    fontFamily: 'Segoe UI',
    fontStyle: 'normal',
    fontWeight: '500',
    textAlign: 'center',
    fontSize: '32px',
    color: (selected) => (selected ? colors.white : colors.grey),
    lineHeight: 1.4,
  },
  skeleton: {
    borderRadius: '4px',
    width: '100%',
    height: '200px',
  }
}));

const Team = ({ onClickTeam, selected, label }) => {
  const classes = useStyles(selected);
  const value = useContext(CurrentContext);
  return (value ?
    <Skeleton
      className={classes.skeleton}
      variant='rect' />
    :
    <Box
      className={classes.root}
      onClick={() => onClickTeam()}
    >
      <Typography variant="h5" className={classes.heading}>
        {label || 'Unknown'}
      </Typography>
    </Box>
  );
};

Team.propTypes = {
  label: PropTypes.string.isRequired,
  onClickTeam: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired,
};

export default Team;
